module.exports = __webpack_public_path__ + "img/icon-satisfied.a710add.svg";